<template>
	<div class="quesstion">
        <div class="title"><span style="color:red;">*</span>{{sortNum}}、{{questionData.question}}<span style="color:#ccc">{{questionData.tip}}</span></div>
        <div class="answer">
            <el-input v-model="input" placeholder="请输入您的意见" @input="getVal"></el-input>
        </div>
	</div>
</template>
<script>
export default {
    name: "answer",
    props: {
		questionData:{
			type:Object,
			default:{}
        },
        sortNum:{
            type:Number,
            default:0
        },
        isReset:{
            type:Boolean,
            default:false
        }
	},
    data() {
        return {
            input:''
        }
    },
    mounted() {
        
    },
	watch:{
		isReset:{
            handler(newVal,oldVal){
                if(newVal){
                    this.input = '';
                }
            },
            immediate:true
        }
	},
    methods: {
        getVal(){
            let parms = {
                    id:this.questionData.id,
                    questionnaireIssuesId:this.questionData.questionnaireIssuesId,
                    options:[{"answer":this.input}]
                }
            this.$emit('getAnswerdata',parms);  
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/questionAnswer.vue